import { useDispatch } from 'react-redux';

import { closeModal } from 'reducers/modalReducer';

import StandardModal from 'modals/StandardModal';
import './ConfirmModal.css';

const ConfirmModal = ({ options }) => {
	const dispatch = useDispatch();
	const title = options.title || 'Are you sure?';
	const color = options.color || 'primary';
	const confirmLabel = options.confirmLabel || 'Confirm';
	const closeLabel = options.closeLabel || 'Close';
	const onConfirm = options.onConfirm || (() => {});
	const message = options.message || 'Are you sure?';
	const children = options.children;
	const noConfirmButton = options?.noConfirmButton || false;

	const handleConfirm = () => {
		onConfirm();
		dispatch(closeModal());
	};

	if (noConfirmButton) {
		return (
			<StandardModal
				title={title}
				className="violerts-v3-root confirm-modal"
				size="md"
				closeOnOutsideClick={false}
				closeLabel={closeLabel}
			>
				<div className="confirm-modal-body">{children || message}</div>
			</StandardModal>
		);
	}

	return (
		<StandardModal
			title={title}
			className="violerts-v3-root confirm-modal"
			size="md"
			closeOnOutsideClick={false}
			onConfirm={handleConfirm}
			confirmText={confirmLabel}
			closeLabel={closeLabel}
			confirmColor={color}
		>
			<div className="confirm-modal-body">{children || message}</div>
		</StandardModal>
	);
};

export default ConfirmModal;
